import React from 'react';
import styled from 'styled-components';
import theme from 'ui/styling/theme';

const BackGround = styled.div`
  height: 100%;
  overflow-y: auto;
  display: flex;
  justify-content: center;
`;

const Wrapper = styled.div`
    margin: 0 auto;
    width: ${(props) => props.theme.pageDefaults.width};
    padding: ${(props) => props.theme.pageDefaults.padding};}
  `;

export interface IPageWrapperProps {
  children: React.ReactChild;
  backgroundColor?: string;
}

const PageWrapper = ({
  children,
  backgroundColor = theme.colors.backgroundGray,
}: IPageWrapperProps) => {
  return (
    <BackGround style={{ backgroundColor }}>
      <Wrapper>{children}</Wrapper>
    </BackGround>
  );
};

export default PageWrapper;
